import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { IPBoardHelper } from 'src/app/helpers/ip-board-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import Product from 'src/app/model/product/product';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { TourItem } from 'src/app/model/tour/tour-item';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { PrintAddressPipe } from 'src/app/pipes/print-address.pipe';
import { ImmoIPPlacerTourViewHelper } from '../../helper/immo-ip-placer-tour-view-helper';

export class ImmoIPPlacerTourListHelper {
  private constructor() {}

  static processTourItems(
    tourItems: TourItem[],
    printAddressPipe: PrintAddressPipe,
    formatPhoneNumber: FormatPhoneNumber
  ): void {
    if (!CollectionHelper.isPopulated(tourItems)) {
      return;
    }
    tourItems.forEach((ti) => {
      ImmoIPPlacerTourViewHelper.setTourItemBackgroundClass(ti);
      if (ti.subProject != null) {
        ImmoIPPlacerTourViewHelper.processSubProject(ti.subProject);
        if (
          ti.subProject.type !== SUB_PROJECT_TYPES.ADJUSTMENT &&
          ti.subProject.project != null &&
          CollectionHelper.isPopulated(ti.subProject.project.products)
        ) {
          this.processProducts(
            ti.subProject.project.products,
            ti.subProject.projectPlacement
          );
        }
        ImmoIPPlacerTourViewHelper.processProjectPlacement(
          ti.subProject,
          printAddressPipe,
          true,
          formatPhoneNumber
        );
        ImmoIPPlacerTourViewHelper.setTypeDisplays(ti.subProject);
      }
    });
  }

  private static processProducts(
    products: Product[],
    projectPlacement: ProjectPlacement
  ): void {
    products.forEach((p, i) => {
      if (ProductHelper.isIPBoard(p)) {
        const ipBoard = <IPBoard>p;
        ipBoard.typeAndMeasurements =
          IPBoardHelper.getTypeAndMeasurementsAndDescription(
            ipBoard,
            ' ',
            true
          );
        this.processTitle(ipBoard);
        if (i === 0 && projectPlacement.secondBoard != null) {
          ipBoard.hasSecondBoard = true;
        }
      }
    });
  }

  private static processTitle(ipBoard: IPBoard): void {
    if (ipBoard.boardPart == null) {
      return;
    }
    if (ipBoard.boardPart.sign != null) {
      if (ipBoard.boardPart.titleAdjustment != null) {
        ipBoard.titleDisplay = ipBoard.boardPart.titleAdjustment.title;
        ipBoard.hasTitleAdjustment = true;
      } else if (ipBoard.boardPart.otherTitleAdjustment != null) {
        ipBoard.titleDisplay = ipBoard.boardPart.otherTitleAdjustment.title;
        ipBoard.hasTitleAdjustment = true;
      } else if (!StringHelper.isEmpty(ipBoard.boardPart.otherTitle)) {
        ipBoard.titleDisplay = ipBoard.boardPart.otherTitle;
        ipBoard.hasTitleAdjustment = true;
      } else if (!StringHelper.isEmpty(ipBoard.boardPart.otherSideOtherTitle)) {
        ipBoard.titleDisplay = ipBoard.boardPart.otherSideOtherTitle;
        ipBoard.hasTitleAdjustment = true;
      } else {
        ipBoard.titleDisplay = ipBoard.boardPart.sign.title;
        ipBoard.hasTitleAdjustment = false;
      }
    } else {
      ipBoard.titleDisplay = StringHelper.isEmpty(ipBoard.boardPart.otherTitle)
        ? ipBoard.boardPart.otherSideOtherTitle
        : ipBoard.boardPart.otherTitle;
      ipBoard.hasTitleAdjustment = false;
    }
  }
}
